<template>
    <div class="cart-item-addon">
        <span v-if="!multiple">{{ name }}<slot></slot></span>
        <span v-if="multiple" v-for="(addon, index) in addons" :key="addon.id">{{ addon.name }}<span v-if="!(addons.length -1 === index)">, </span></span>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Cart Item Addon mounted.');
        },
        props: ['addon_id', 'name', 'price', 'addons', 'multiple', 'category'],
        computed: {}
    }
</script>
